import { ServiceResult } from '../models/api-shared.models';
import {
  GetOrderCartRequest,
  GetOrderHeadersRequest,
  GetOrderRequest,
  GetOrderResultData,
  GetOrderReviewExportRequest,
  GetOrderReviewExportResult,
  GetOrderReviewReportRequest,
  OrderCart,
  OrderHeader,
  OrderReviewExportOptions,
  OrderReviewReport,
} from '../models/order.models';
import ApiService from './api-service';

class OrderService extends ApiService {
  private static classInstance: OrderService;

  private constructor() {
    super('Order');
  }

  public getOrder(request: GetOrderRequest): ServiceResult<GetOrderResultData> {
    return this.get(`${this.baseUrl}/GetOrder`, request);
  }

  /**
   * @deprecated
   */
  public getOrderHeaders(request?: GetOrderHeadersRequest): ServiceResult<OrderHeader[]> {
    return this.get(`${this.baseUrl}/GetOrderHeaders`, request);
  }

  public getOrderCart(request: GetOrderCartRequest): ServiceResult<OrderCart> {
    return this.get(`${this.baseUrl}/GetOrderCart`, request);
  }
  public getOrderReviewReport(request: GetOrderReviewReportRequest): ServiceResult<OrderReviewReport> {
    return this.post(`${this.persistUrl}/GetOrderReviewReport`, request);
  }
  public getOrderReviewExportOptions(): ServiceResult<OrderReviewExportOptions> {
    return this.get(`${this.baseUrl}/GetOrderReviewExportOptions`);
  }
  public getOrderReviewExport(request: GetOrderReviewExportRequest): ServiceResult<GetOrderReviewExportResult> {
    return this.post(`${this.persistUrl}/GetOrderReviewExport`, request);
  }

  public static getInstance(): OrderService {
    if (!this.classInstance) {
      this.classInstance = new OrderService();
    }
    return this.classInstance;
  }
}

export default OrderService;
